module.exports = __webpack_public_path__ + "img/3.c58381c5.jpg";